/** Mobile布局 */

import { Box, Container, AppBar, Toolbar, Typography, IconButton } from '@mui/material';
import { ArrowBack, AccountCircle } from '@mui/icons-material';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import BottomNav from '@/components/mobile/BottomNav';
import { useAppContext } from '@/contexts/AppContext';
import { COLORS } from '@/theme/colors';

export default function MobileLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAppContext();
  const showBack = location.pathname !== '/mobile' && location.pathname !== '/mobile/tasks';

  return (
    <Box sx={{ maxWidth: 480, mx: 'auto', height: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: COLORS.background.default, position: 'relative' }}>
      <AppBar position="sticky" sx={{ backgroundColor: COLORS.primary.main }}>
        <Toolbar>
          {showBack && (
            <IconButton color="inherit" edge="start" onClick={() => navigate(-1)}>
              <ArrowBack />
            </IconButton>
          )}
          <Box
            component="img"
            src="/logo/star-icon.jpg"
            alt="BluPlanet"
            sx={{ width: 28, height: 28, borderRadius: '6px', objectFit: 'contain', mr: 1 }}
          />
          <Typography variant="h6" sx={{ flex: 1, fontWeight: 600, fontSize: '1.0625rem' }}>
            现场实操
          </Typography>
          <IconButton color="inherit">
            <AccountCircle />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Box sx={{ flex: 1, overflow: 'auto', pb: 8 }}>
        <Container maxWidth="sm" sx={{ py: 2 }}>
          <Outlet />
        </Container>
      </Box>
      <BottomNav />
    </Box>
  );
}
